module.exports = __webpack_public_path__ + "static/media/GCC.e2f2dc24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/GCC.jpg
// module id = 988
// module chunks = 0